import { ReactNode, isValidElement, useState } from 'react';
import styles from './style.module.css';

interface IList {
  children: ReactNode;
}
interface IListItem {
  image?: string | ReactNode;
  icon?: string;
  colorIcon?: any;
  styleIcon?: 'outlined' | 'normal';
  content: any;
  withRange?: boolean;
  rangeChecked?: boolean;
  secondaryContent?: any;
  expansible?: boolean;
  defaultExpanded?: boolean;
  contentExpansible?: JSX.Element;
  onClick?: () => void;
  cursorPointer?: boolean;
  inputType?: string;
  classStyle?: string;
  key?: any;
  handleChange?: () => void;
}

function List({ children }: IList) {
  return (
    <>
      <ul className={styles.list}>{children}</ul>
    </>
  );
}

function ListItem({
  image,
  icon,
  colorIcon,
  styleIcon,
  content,
  secondaryContent,
  expansible,
  defaultExpanded,
  contentExpansible,
  withRange,
  rangeChecked,
  cursorPointer,
  inputType,
  classStyle,
  handleChange,
  ...rest
}: IListItem) {
  const [isOpen, setIsOpen] = useState(defaultExpanded ?? false);

  function handleExpansible(e: any) {
    e.preventDefault();
    setIsOpen(!isOpen);
  }

  return (
    <li
      className={`${styles.listItem} ${
        cursorPointer ? styles.cursorTrue : ''
      } ${classStyle ? classStyle : ''}`}
      {...rest}
    >
      <div className={styles.content}>
        <span>
          {withRange && (
            <input
              onChange={handleChange}
              checked={rangeChecked}
              className="me-3"
              type={inputType ? inputType : 'radio'}
              name=""
              id=""
            />
          )}
          {image &&
            (isValidElement(image) ? (
              <span className="me-3">{image}</span>
            ) : (
              <img className="me-3" src={image as string} alt="" />
            ))}
          {icon && (
            <span
              className={`${styles.iconListItem} me-3`}
              style={{ backgroundColor: colorIcon ? colorIcon : '' }}
            >
              <i
                className={`${
                  styleIcon && styleIcon === 'outlined'
                    ? 'material-icons-outlined'
                    : 'material-icons'
                }`}
                style={{ color: colorIcon ? '#fff' : '' }}
              >
                {icon}
              </i>
            </span>
          )}
          {<span>{content}</span>}
        </span>
        {!expansible && <span>{secondaryContent}</span>}
        {expansible && (
          <div className="d-flex align-items-center">
            <span>{secondaryContent}</span>
            <button className="btn rounded-circle" onClick={handleExpansible}>
              <i className="material-icons-outlined ms-3 color-text">
                {!isOpen ? 'expand_more' : 'expand_less'}
              </i>
            </button>
          </div>
        )}
      </div>
      {expansible && isOpen && (
        <div className={`${styles.contentExpansible} mt-3 p-3`}>
          {contentExpansible}
        </div>
      )}
    </li>
  );
}

export { List, ListItem };
